import { Wrapper, Cleanstate, Durations, Duration } from './styles'

Wrapper.Cleanstate = Cleanstate
Wrapper.Durations = Durations
Wrapper.Duration = Duration

export default Wrapper
